import { createFileRoute } from '@tanstack/react-router';
import { WorkSheetStepDetailPage } from '@/features/work-orders/components/worksheet-detail/WorkSheetStepDetailPage';

export interface WorkSheetStepDetailSearch {
	additionalProtocolId?: string;
}

export const Route = createFileRoute('/_authenticated/work-orders/$id/worksheets/$worksheetId/steps/$stepId')({
	validateSearch: (search: Record<string, unknown>): WorkSheetStepDetailSearch =>
		typeof search.additionalProtocolId === 'string' ? { additionalProtocolId: search.additionalProtocolId } : {},
	component: WorkSheetStepDetail,
});

function WorkSheetStepDetail() {
	const { id, worksheetId, stepId } = Route.useParams();
	const { additionalProtocolId } = Route.useSearch();
	return <WorkSheetStepDetailPage workOrderId={id} worksheetId={worksheetId} stepId={stepId} additionalProtocolId={additionalProtocolId} />;
}
